import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { VendorAlpsPopupComponent } from './vendor-alps-popup.component';
import { DxTooltipModule, DxAccordionModule, DxFileUploaderModule, DxNumberBoxModule, DxTextAreaModule } from 'devextreme-angular';
import { DxTemplateModule, DxDropDownButtonModule, DxButtonModule, DxCheckBoxModule, DxRadioGroupModule, DxTagBoxModule, DxScrollViewModule, DxTextBoxModule, DxDataGridModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule, DxAutocompleteModule } from "devextreme-angular";

@NgModule({
  declarations: [
    VendorAlpsPopupComponent
  ],
  imports: [
    CommonModule,
    DxButtonModule,
    DxTagBoxModule,
    MdbGlobalModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxRadioGroupModule,
    DxCheckBoxModule,
    DxAutocompleteModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxAccordionModule,
    DxTemplateModule,
    DxFileUploaderModule,
    DxTooltipModule,
    TranslateModule,
    DxDropDownButtonModule,
    FormsModule, 
    ReactiveFormsModule
  ],
  exports:[VendorAlpsPopupComponent]
})
export class VendorAlpsPopupModule { }
